import React, { useState } from "react";
import './ResetPassword.css'
// Assets
import Swal from 'sweetalert2'
import emailIcon from '../Assets/email.png'
import passwordIcon from '../Assets/password.png'
import confirmCodeIcon from '../Assets/confirmCode.png'
import surgeonslab_logo from '../Assets/surgeonslab_logo.png'
import { generateClient } from "aws-amplify/api"
import { resetPassword, confirmResetPassword } from "aws-amplify/auth";

const SignUp = () => {

    // const { page } = useParams();
    // console.log('Page:', page);
    const API = generateClient();

    const [newPassword, setNewPassword] = useState('');
    const [username, setUsername] = useState('');
    const [Mentorname, setMentorname] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    let username_OG;

    const handleClick = () => {
      if(username.length != 0){
            setAction("Confirm Reset Password");
            handleRestPassword();
      }
      else {
        Swal.fire({
            title: "Error!",
            text: "Fill in email to continue",
            icon: "error"
        }); 
      }
    };

    const handleRestPassword = async (e) => {
        console.log('working')
        try {
            const output = await resetPassword({ username });
            const { nextStep } = output;
            switch (nextStep.resetPasswordStep) {
            case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
                const codeDeliveryDetails = nextStep.codeDeliveryDetails;
                console.log(
                `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
                );
                // Collect the confirmation code from the user and pass to confirmResetPassword.
                break;
            case 'DONE':
                console.log('Successfully reset password.');
                break;
            }
        } catch (err) {console.log('error : ', err)}
    }

    const handleRestPasswordConfirmation = async (e) => {
        if(username.length != 0 && newPassword.length != 0 && confirmationCode.length != 0){
            try {
                await confirmResetPassword({ username, confirmationCode, newPassword });
                console.log('reset password success')
                Swal.fire({
                    title: "Success!",
                    text: "Password reset successful!   ",
                    icon: "success"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // User clicked "OK", execute function
                      window.location.reload();
                    }}); 
            } catch (error) {
                Swal.fire({
                    title: "Error!",
                    text: "Error resetting your passsword",
                    footer: error.message,
                    icon: "error"
                  }); 
                console.log(error);
            }
    }
    else{
        Swal.fire({
            title: "Error!",
            text: "Fill in all details",
            icon: "error"
        }); 
    }
}
    


    const [action, setAction] = useState("Reset Password");
    const submitStyle = {
        background: '#033030',
      };
    const textStyle = {
        color: '#033030',
      };

    return (
        <div className="NavBar">
            <nav>
                <div className="logo">
                    <img className="logoPic" src={surgeonslab_logo} alt="SurgeonsLab Logo" />
                </div>
            </nav>

            <div className='container'>
                <div className="header">
                    <div className="text" style={textStyle}>{action}</div>
                    <div className="underline" style={submitStyle}></div>
                </div>
                <div className="inputs">
                    <div className="input">
                        <img src={emailIcon} alt="Email" />
                        <input type="email" placeholder="Email" id="email" value={username} onChange={(e) => setUsername(e.target.value)} />
                    </div>
                    {action === "Confirm Reset Password" ? <div></div> :
                    <div className="submit-container">
                        <div className="submit" onClick={handleClick} style={submitStyle}>Next</div>
                    </div>
                    } 
                    {/*() => { setAction("Confirm Reset Password") }*/}
                    {action === "Reset Password" ? <div></div> :
                    <div className="input">
                        <img src={confirmCodeIcon} alt="Code" />
                        <input type="text" placeholder="Authentication Code" id="confirmationCode" value={confirmationCode} onChange={(e) => setConfirmationCode(e.target.value)} />
                    </div>
                    }
                    {action === "Reset Password" ? <div></div> :
                    <div className="input">
                        <img src={passwordIcon} alt="Password" />
                        <input type="password" placeholder="New Password" id="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                    </div>
                    }

                </div>

                <div className="submit-container">
                    {action === "Reset Password" ? <div></div> :
                        <div className={action === "Sign Up" ? "submit gray" : "submit"} onClick={handleRestPasswordConfirmation}>Submit</div>
                    }
                </div>

            </div>
        </div>
    );
};

export default SignUp;